import { createTheme } from '@mui/material/styles';


// Definindo o tema com as cores personalizadas
const theme = createTheme({
  palette: {
    primary: {
      main: '#18E8DB',
      light: '#4FEDE2',
      dark: '#15D5C9',
      contrastText: '#282828', // Cor do texto quando sobre primary.main
    },
    secondary: {
      main: '#F49841',
      light: '#F7B06A',
      dark: '#F2852A',
      contrastText: '#282828', // Cor do texto quando sobre secondary.main
    },
    success: {
      main: '#4CAF50',
      light: '#81C784',
      dark: '#388E3C',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#F44336',
      light: '#E57373',
      dark: '#D32F2F',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FF9800',
      light: '#FFB74D',
      dark: '#F57C00',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      paper: '#282828',
      container: '#F2F2F2',
      primary: "#18E8DB"
    },
    text: {
      primary: '#282828',
      secondary: '#666666'
    },
    divider: '#E0E0E0',
  },
  colors: {
    primary: '#18E8DB',
    secondary: '#F49841',
    dark: '#282828',
    light: '#FFFFFF'
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none', // Remove o background padrão
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#f5f5f5',
          '& .MuiAutocomplete-option': {
            '&:hover': {
              backgroundColor: '#e0e0e0', // Cor quando passa o mouse
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: "#282828", // Cor do label normal
            '&.Mui-focused': {
              color: "#18E8DB", // Cor do label quando em foco
            },
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff', // Fundo branco
          color: '#333333', // Cor do texto
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#000000", // Cor preta quando desmarcado
          '&.Mui-checked': {
            color: "#18E8DB", // Cor primária quando marcado
          },
          '&:hover': {
            backgroundColor: 'rgba(24, 232, 219, 0.08)', // Efeito hover sutil
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-colorSuccess': {
            backgroundColor: '#2E7D32', // Verde forte para Excelente
            color: '#FFFFFF',
          },
          '&.MuiChip-colorError': {
            backgroundColor: '#D32F2F', // Vermelho para Ruim
            color: '#FFFFFF',
          },
          '&.MuiChip-colorWarning': {
            backgroundColor: '#FF9800', // Amarelo/Laranja para Regular
            color: '#FFFFFF',
          },
          '&.MuiChip-colorDefault': {
            backgroundColor: '#757575', // Cinza para não informado
            color: '#FFFFFF',
          },
        },
      },
    }
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
});

export default theme;
